enum API_ERROR {
  AXIOS_RES = 'Axios.ResponseError',
  AXIOS_RES_NULL = 'Axios.ResponseNullError',
  AXIOS_REQ = 'Axios.RequestError',
  API_PROXY = 'API.ProxyError',
  MISS_RESPONSE = 'MissParameters.Response',
}

export default API_ERROR;
